// @ts-nocheck
import React, {useEffect, useState} from "react";
import Input from "../atoms/Input";
import Image from "next/image";
import {ArrowLeftIcon, ExclamationIcon, MailIcon} from "@heroicons/react/outline";
import {useApplicationContext} from "../../../../context/ApplicationContext/ApplicationContext";
import {updateConfiguration} from "../../../../context/ApplicationContext/actions";
import Link from "next/link";
import {event} from "../../../../services/analytics";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import {useSession} from "next-auth/react";
import {useRouter} from "next/router";
import {sendTestEmail} from "../../../../services/api";
import {URLS} from "../../../../constants";
import {publicEnv} from "@app/core-app/pub-env";
import {useProfile} from "../../../../data/profile";
import {Box, Button, CircularProgress, Text, VStack} from "@chakra-ui/react";
import WorkspacePageSelector from "./WorkspacePageSelector";
import {useAvailablePages} from "../../../../data/pages";
import {EditRenderPreferencesModal} from "../../organisms/EditRenderPreferencesModal";


export type EmailConfigurationProps = {
    className?: string
}

const EmailConfiguration: React.FC<EmailConfigurationProps> = ({className}) => {
  const {state, dispatch} = useApplicationContext()

  const enableCaptcha = publicEnv.CAPTCHA_ENABLED
  const captchaSiteKey = publicEnv.CAPTCHA_SITE_KEY

  const [email, setEmail] = useState("")
  const [sendResult, setSendResult] = useState(null)
  const hcaptchaRef = React.useRef(null);
  const {data: session} = useSession()

  const {data} = useProfile({isAuthorized: !!session?.user?.email})
  const {data: pages, isLoading: pagesLoading} = useAvailablePages({isAuthorized: !!session?.user?.email})

  const onSendEmail = (token) => {
    setSendResult("progress")
    sendTestEmail({pageUrl: state.configuration.pageLink, email: email, content: state.result.body, captcha: token})
      .then((data) => {
        if (data.ok) {
          setSendResult("sent")
        } else {
          setSendResult("error")
        }
      })
      .catch(() => setSendResult("error"))
    event({
      action: "email_send_click",
      params: {
        email: email
      }
    })
  }

  useEffect(() => {
    setEmail(data?.profile?.email || "")
  }, [data?.profile?.email])

  const demoPageLink = "https://nsender.notion.site/b943584931424c31b97eeff296911ede"

  const router = useRouter()

  useEffect(() => {
    if (!router.isReady) return;

    const pageUrl = router.query['pageUrl']

    if (typeof pageUrl === "string") {
      updateConfiguration(dispatch, {...(state.configuration), pageLink: pageUrl})
    }

  }, [router.isReady, dispatch]);
  return <div className={className}>
    <div className={""}>
      <div className={"py-4 flex justify-between items-center pr-4"}>
        <div>
          <a className={"space-x-2 text-gray-800 text-sm hover:text-blue-500"} onClick={() => router.back()}>
            <span className={"cursor-pointer"}>
              <ArrowLeftIcon className={"h-5 w-5 inline"}/></span>
            <span className={"cursor-pointer"}>Back</span>
          </a>
        </div>

        {!session?.user?.email &&
          <div className={"text-gray-800 text-sm cursor-pointer hover:text-blue-500"}>
            <Link href={URLS.LOGIN} legacyBehavior>
              <a>Log in</a>
            </Link>
          </div>
        }


        {session?.user?.email &&
          <div className={"text-gray-800 text-sm cursor-pointer hover:text-blue-500"}>
            <Link href={URLS.APP_HOME} legacyBehavior>
              <a>Home</a>
            </Link>
          </div>
        }


      </div>

      <h1 className={"text-lg font-medium"}>Create email from notion page</h1>
      <div className={"text-xs text-gray-500 my-1 space-y-1"}>
        <p>Paste Notion page URL in the input.</p>
        <p>Page should be public or your need to have Notion workspace connected.</p>

      </div>
      <div className={"flex"}>
        <Input
          className={"w-4/5 h-10 my-2 text-lg"}
          value={state.configuration.pageLink}
          defaultValue={state.configuration.pageLink}
          placeholder={"Notion page link"}
          icon={
            <Image className={"h-5 w-5 text-gray-400"}
              src="/icons/notion.svg"
              alt="Notion Logo" width={20}
              height={20}/>
          }
          onChange={(link) => {
            updateConfiguration(dispatch, {...(state.configuration), pageLink: link})
            event({
              action: "new_link_submitted",
              params: {
                link: link
              }
            })

          }}
          inputId={"page_link"}

        />
        {state.result.inProgress &&
          <div className={"flex items-center align-center ml-4"}>
            <CircularProgress size={6} isIndeterminate color='blue.500'/>
          </div>
        }
      </div>


      {!!session?.user && <Box my={1}>
        <Text className="text-gray-500" fontSize={"xs"}>Select recently edited page from your workspace</Text>
        <WorkspacePageSelector isLoading={pagesLoading} className={"w-4/5 h-10 my-1 text-xs"} pages={pages}
          onChange={(pageId) => {
            const page = pages?.find(p => p.id === pageId)
            if (page) {
              event({
                action: "page_selected_from_workspace",
                params: {}
              })
              updateConfiguration(dispatch, {...(state.configuration), pageLink: page.raw.url})
            }
          }}/>
      </Box>
      }

      <div className={"text-xs text-gray-500 my-1 space-y-1"}>
        <span className={"cursor-pointer"}
          onClick={() => {
            event({action: "try_sample_page_click", params: {}})
            updateConfiguration(dispatch, {...(state.configuration), pageLink: demoPageLink})
          }}>
          Try sample page by clicking here <a className={"text-blue-500 text-xs"}>{demoPageLink}</a>
        </span>
      </div>

      {state.result.error &&
        <div className={"my-2"}>
          <div className={"text-sm text-red-500 font-medium flex"}>
            <ExclamationIcon className={"h-5 w-5"}/>
            <div className={"mx-1"}>{state.result.error}</div>
          </div>
        </div>
      }

      {state.result.alerts && state.result.alerts.length > 0 &&
        state.result.alerts.map((alert, index) =>
          <div key={`alert-${index}`} className={"my-2 text-orange-500 flex"}>
            <div className={""}>
              <ExclamationIcon className={"h-5 w-5"}/>
            </div>
            <div className={"mx-1"}>
              <div className={"text-sm font-medium"}>{alert.title}</div>
              <div className={"text-xs text-gray-500"}>
                {alert.description}
              </div>
            </div>

          </div>)
      }

    </div>

    <VStack my={4} alignItems={"start"} spacing={4}>
      {state.configuration.pageConfig &&
        <EditRenderPreferencesModal
          title={"Configure Render Parameters"}
          variant={"solid"}
          renderPreferences={state.configuration.pageConfig}
          onSave={(config) => {
            updateConfiguration(dispatch, {...(state.configuration), pageConfig: config})
          }}/>
      }
    </VStack>

    <div className={"mt-6"}>
      <div className={"text-lg font-medium mb-1"}>Send page as an email</div>

      <div className={"text-xs text-gray-500 mb-2"}>
        Send email to anybody or receive it to your inbox for forwarding or customization.
      </div>
      <div className={"flex"}>

        <Input inputId={"email_address"}
          className={"w-3/5 h-10 my-1 text-xs"}
          placeholder={"Email address"}
          value={email}
          icon={<MailIcon className={"w-5 h-5"}/>}
          onChange={(data) => {
            setEmail(data)
            setSendResult(false)
          }}/>


        {sendResult === "progress" &&
          <div className={"flex items-center align-center ml-4"}>
            <Image className={"h-5 w-5"}
              src="/loader.svg"
              alt="Loader" width={24}
              height={24}/>
          </div>
        }
      </div>

      {sendResult === "sent" &&
        <div className={"text-sm font-medium py-1 text-green-500 px-1"}>
          Email is sent! 🎉
        </div>
      }

      {sendResult === "error" &&
        <div className={"text-sm font-medium py-1 text-red-500 px-1"}>
          Error happened</div>
      }

      <div>
        {enableCaptcha && <HCaptcha
          id="test"
          sitekey={captchaSiteKey}
          size="invisible"
          ref={hcaptchaRef}
          onVerify={(token) => {
            onSendEmail(token)
          }}/>}

      </div>
      <Button my={4} size={"sm"} colorScheme={"gray"} variant={"outline"} bgColor={"white"} onClick={() => {
        if (state.result.body && email) {
          if (enableCaptcha) {
            hcaptchaRef.current.execute()
          } else {
            onSendEmail(null)
          }
        }
      }}>
        Send Email
      </Button>

    </div>


  </div>
}
export default EmailConfiguration;
